export const useSiteData = () => useState<any>('sitedata', () => {})
export const useUserData = () => useState<any>('userdata', () => {})
export const useAuthenticated = () => useState<any>('authenticated', () => false)
export const useScreenshotUploaded = () => useState<any>('screenshotUploaded', () => '')
